<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <fragment>
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            </fragment>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- //contents_head -->
            <div class="register_wrap">
                <div class="step_wrap">
                    <ul>
                        <!-- 활성화 STEP class -->
                        <li
                            :class="getActiveClass(item.code, item.index)"
                            v-for="item in stepList"
                            :key="step + item.index + item.codeName"
                        >
                            <em>{{ item.index }}</em>
                            <p>{{ item.codeName }}</p>
                        </li>
                    </ul>
                </div>
                <table class="create_table">
                    <colgroup>
                        <col width="154" />
                        <col width="*" />
                        <col width="154" />
                        <col width="*" />
                    </colgroup>
                    <caption>
                        <em class="txt_mandatory">*</em>
                        {{
                            $t('FIELD.GLOBAL.MANDATORY')
                        }}
                    </caption>
                    <tr>
                        <th>{{ $t('FIELD.GLOBAL.VERSION') }}<em class="txt_mandatory" v-if="'Q' === step">*</em></th>
                        <td>
                            <span class="clearable" v-if="'Q' === step">
                                <input type="text" class="text_input w100p" v-clearable v-model="version" />
                            </span>
                            <div v-else>{{ version }}</div>
                        </td>
                        <th>OLD Version<em class="txt_mandatory" v-if="'Q' === step">*</em></th>
                        <td>
                            <span class="clearable" v-if="'Q' === step">
                                <input type="text" class="text_input w100p" v-clearable v-model="oldVersion" />
                            </span>
                            <div v-else>{{ oldVersion }}</div>
                        </td>
                    </tr>
                    <tr>
                        <th>{{ $t('FIELD.CODE.TITLE') }} <em class="txt_mandatory" v-if="'Q' === step">*</em></th>
                        <td>
                            <span class="clearable" v-if="'Q' === step">
                                <input
                                    type="text"
                                    class="text_input w100p"
                                    placeholder="Enter subject with less than 90 characters"
                                    v-clearable
                                    maxlength="90"
                                    v-model="title"
                                />
                            </span>
                            <div v-else>{{ title }}</div>
                        </td>
                        <td colspan="2" class="pl-20 txt_warning">
                            <span v-show="!title">※ Enter subject with less than 90 characters.</span>
                        </td>
                    </tr>
                    <tr>
                        <th colspan="4" class="div_wrap">
                            {{ $t('FIELD.KNOWLEDGE.VERHISTORY') }}
                            <em v-if="'Q' === step || [1, 3, 5, 7].includes(modify)" class="txt_mandatory">*</em>
                            <a
                                v-else-if="modifys.includes(status)"
                                href="javascript:"
                                class="ico_write_global"
                                @click="modifyBtn(1)"
                            >
                                <span class="sr_only"></span>
                            </a>
                        </th>
                    </tr>
                    <tr class="border_top_none">
                        <td colspan="4" class="div_wrap">
                            <div class="namo_wrap">
                                <table class="data_table">
                                    <colgroup>
                                        <col width="10%" />
                                        <col width="10%" />
                                        <col width="15%" />
                                        <col width="*" />
                                    </colgroup>
                                    <thead>
                                        <tr class="text_center">
                                            <th>{{ $t('FIELD.GLOBAL.VERSION') }}</th>
                                            <th>{{ $t('BUTTON.FAST.DATE') }}</th>
                                            <th>{{ $t('FIELD.GLOBAL.EDITOR') }}</th>
                                            <th>{{ $t('FIELD.GLOBAL.DETAILS') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody class="text_center">
                                        <tr>
                                            <td class="pc_only">
                                                {{ version }}
                                            </td>
                                            <td class="pc_only">
                                                {{ date }}
                                            </td>
                                            <td class="pc_only">{{ loginName }}</td>
                                            <td class="text_left">
                                                <textarea
                                                    class="toolTextArea"
                                                    v-model="details"
                                                    v-if="'Q' === step || [1, 3, 5, 7].includes(modify)"
                                                ></textarea>
                                                <div v-else v-html="getMessage(details)"></div>
                                            </td>
                                        </tr>
                                        <tr v-for="info in versionList">
                                            <td>{{ info.VERSION }}</td>
                                            <td class="pc_only">{{ info.REG_DATE }}</td>
                                            <td class="pc_only">{{ info.REG_NAME }}</td>
                                            <td class="text_left">
                                                <div>{{ info.DESCRIPTION }}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th colspan="4">
                            {{ $t('FIELD.TEST.RESULT') }}
                            <em v-if="'Q' === step || [2, 3, 6, 7].includes(modify)" class="txt_mandatory">*</em>
                            <a
                                v-else-if="modifys.includes(status)"
                                href="javascript:"
                                class="ico_write_global"
                                @click="modifyBtn(2)"
                            >
                                <span class="sr_only"></span>
                            </a>
                        </th>
                    </tr>
                    <tr class="border_top_none">
                        <td colspan="4" v-show="'Q' === step || [2, 3, 6, 7].includes(modify)">
                            <cross-editor :editorId="pageName" :editorData="stripHtml(testResult)"></cross-editor>
                        </td>
                        <td colspan="4" v-show="!('Q' === step || [2, 3, 6, 7].includes(modify))">
                            <div class="namoClass" v-html="stripHtml(testResult)"></div>
                        </td>
                    </tr>
                    <!-- 200513수정 E -->
                    <tr v-show="'Q' === step">
                        <th colspan="4">
                            <span class="fL">{{ $t('FIELD.ATTACH.TOOL') }}</span>
                            <span class="gridtop_wrap_th fL">
                                <em class="txt_info">
                                    {{ $t('MESSAGE.ATTACH.INTERNET.EXPLORER') }}
                                </em>
                            </span>
                        </th>
                    </tr>
                    <tr class="border_top_none" v-show="'Q' === step">
                        <td colspan="4" class="div_wrap">
                            <innorix-upload
                                v-if="attachToolView && 'Q' === step"
                                :id="pageName + 'AttachTool'"
                                :name="pageName + 'AttachTool'"
                                :uploadId="pageName + 'AttachTool'"
                                :onlyUpload="onlyUpload"
                                :attachList="attachTool"
                                :serviceType="serviceType"
                                :toolManager="path"
                                @files="setToolFiles"
                            />
                            <innorix-download
                                v-if="attachTool.length > 0 && attachToolView && 'Q' !== step"
                                :uploadId="pageName + 'AttachTool'"
                                :serviceType="serviceType"
                                :attachList="attachTool"
                            />
                        </td>
                    </tr>
                    <tr v-show="'Q' !== step">
                        <th colspan="4">
                            <span class="fL">{{ $t('FIELD.ATTACH.MANUAL') }}<em class="txt_mandatory">*</em></span>
                        </th>
                    </tr>
                    <tr v-show="'Q' !== step">
                        <td colspan="4" class="div_wrap">
                            <innorix-upload
                                v-if="attachManualView && modifys.includes(status)"
                                :id="pageName + 'attachManual'"
                                :name="pageName + 'attachManual'"
                                :uploadId="pageName + 'attachManual'"
                                :onlyUpload="onlyUpload"
                                :attachList="attachManual"
                                :serviceType="serviceType"
                                @files="setManualFiles"
                            />
                            <innorix-download
                                v-if="attachTool.length > 0 && attachManualView && !modifys.includes(status)"
                                :uploadId="pageName + 'attachManual'"
                                :serviceType="serviceType"
                                :attachList="attachManual"
                            />
                        </td>
                    </tr>
                    <tr v-if="'P' === step">
                        <th>{{ $t('FIELD.PILOT.TESTER') }}</th>
                        <td colspan="3">
                            <table class="data_table">
                                <colgroup>
                                    <col width="45%" />
                                    <col width="45%" />
                                    <col width="*" />
                                </colgroup>
                                <thead>
                                    <tr class="text_center">
                                        <th>{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}</th>
                                        <th>{{ $t('FIELD.ASCCENTER.NO') }}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody class="text_center">
                                    <tr v-for="(item, idx) in pilotList">
                                        <td>
                                            <label class="serial-wrap">
                                                <input type="text" class="text_input w100p" v-model="item.SUBSIDIARY" />
                                            </label>
                                        </td>
                                        <td>
                                            <label class="serial-wrap">
                                                <input type="text" class="text_input w100p" v-model="item.ASC" />
                                            </label>
                                        </td>
                                        <td class="text_right">
                                            <span class="in-btn-item">
                                                <a
                                                    v-if="idx === pilotList.length - 1"
                                                    href="javascript:"
                                                    class="ico_btn_add"
                                                    @click="btnAddSerial()"
                                                >
                                                    <span class="sr_only">{{ $t('BUTTON.GLOBAL.ADD') }}</span>
                                                </a>
                                                <a
                                                    href="javascript:"
                                                    class="ico_btn_remove"
                                                    @click="btnRemoveSerial(idx)"
                                                >
                                                    <span class="sr_only">{{ $t('BUTTON.GLOBAL.REMOVE') }}</span>
                                                </a>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="btn_wrap_full topLine">
                <a href="javascript:" class="btn_white size_full" @click="pageMove('toolManageList')">List</a>
                <span
                    class="pl-20 txt_warning"
                    v-show="
                        !version ||
                            !oldVersion ||
                            (0 === attachToolFileSeq.length && 0 === attachTool.length) ||
                            ('Q' !== step && 0 === attachManualFileSeq.length && 0 === attachManual.length)
                    "
                >
                    ※ Check the mandatory field(s).
                </span>
                <div class="btn_right" v-show="'Complete' === status && 'Y' === params.creationYn">
                    <a href="javascript:" class="btn_white" @click="seeNotificationPop()">
                        Notification
                    </a>
                    <a
                        href="javascript:"
                        class="btn_blue"
                        v-if="'O' === step && 'O' !== reqType && 'Complete' === status"
                        @click="request(step)"
                    >
                        {{ $t('FIELD.PUBLIC.RELEASE') }}
                        <em class="ico_infoW_btn">
                            <i class="tooltip fl_right">
                                {{ $t('MESSAGE.PUBLIC.RELEASE') }}
                            </i>
                        </em>
                    </a>
                </div>
                <div class="btn_right" v-show="'Release' === status">
                    <a href="javascript:" class="btn_blue" @click="seeApprovalHistoryPop(approvalId)">
                        {{ $t('FIELD.GLOBAL.ETC.001') }}
                    </a>
                </div>
                <div class="btn_right" v-show="modifys.includes(status) && 'Y' === params.creationYn">
                    <a href="javascript:" class="btn_white" @click="seeNotificationPop()">
                        Notification
                    </a>
                    <a
                        href="javascript:"
                        class="btn_white"
                        v-if="'' !== toolId && 'Complete' !== status"
                        @click="save('Discard')"
                    >
                        Discard
                    </a>
                    <a href="javascript:" class="btn_white" v-if="'Complete' !== status" @click="save('Draft')">
                        {{ $t('FIELD.GLOBAL.DRAFT') }}
                    </a>
                    <a
                        href="javascript:"
                        class="btn_blue"
                        v-if="'Q' === step && 'Q' !== reqType"
                        @click="request(step)"
                    >
                        {{ $t('FIELD.UPLOAD.QASERVER') }}
                        <em class="ico_infoW_btn">
                            <i class="tooltip fl_right">
                                {{ $t('MESSAGE.GSPN.QA.SERVER') }}
                            </i>
                        </em>
                    </a>
                    <a
                        href="javascript:"
                        class="btn_white"
                        v-if="'P' === step && 'P' !== reqType"
                        @click="request(step)"
                    >
                        {{ $t('FIELD.PLIOT.RELEASE') }}
                        <em class="ico_info_btn">
                            <i class="tooltip fl_right">
                                {{ $t('MESSAGE.PLIOT.RELEASE') }}
                            </i>
                        </em>
                    </a>
                    <a href="javascript:" class="btn_blue" @click="next(step)" v-if="!['Q', 'O'].includes(step)">
                        {{ $t('BUTTON.GLOBAL.NEXT') }}
                    </a>
                    <a
                        href="javascript:"
                        class="btn_blue"
                        @click="next(step)"
                        v-if="'O' === step && ['Draft', 'Ongoing', 'Rejected', 'Canceled'].includes(status)"
                    >
                        {{ $t('TITLE.GLOBAL.APPROVAL') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import moment from 'moment';
import constants from '@/constants';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import CrossEditor from '~c/CrossEditor';
import InnorixUpload from '~c/InnorixUpload';
import InnorixDownload from '~c/InnorixDownload';
import ApprovalPopup from '~c/popup/ApprovalPopup';
import ApprovalHistoryPopup from '~c/popup/ApprovalHistoryPopup';
import toolManagePopup from '~va/tool/toolManagePopup';

require('moment-jdateformatparser');

export default {
    name: 'toolManageDetail',
    components: {
        'cross-editor': CrossEditor,
        'skp-breadcrumbs': SKPBreadcrumbs,
        'innorix-upload': InnorixUpload,
        'innorix-download': InnorixDownload,
    },
    data() {
        return {
            pageName: 'toolManageDetail',
            pageTitle: '',
            reqSystem: '',
            reqType: '',
            toolId: '',
            step: 'Q',
            status: '',
            version: '',
            oldVersion: '',
            versionList: [],
            title: '',
            details: '',
            date: '',
            testResult: '',
            approvalId: '',
            approvalStatus: '',
            path: 'QA_GLIV',
            pilotList: [],
            stepList: [],
            loginId: JSON.parse(localStorage.getItem('loginUser')).loginId,
            loginName: JSON.parse(localStorage.getItem('loginUser')).loginName,
            modify: 0,
            modifys: ['', 'Draft', 'Ongoing', 'Rejected', 'Canceled', 'Error'],
            serviceType: 'common',
            attachTool: [],
            attachManual: [],
            onlyUpload: false,
            attachToolFileSeq: [],
            delAttachToolFiles: [],
            attachToolIsRemove: false,
            attachManualFileSeq: [],
            delattachManualFiles: [],
            attachManualIsRemove: false,
            attachToolView: false,
            attachManualView: false,
        };
    },
    computed: {
        ...mapGetters({
            curLoginNo: 'getLoginNo',
            params: 'getParams',
        }),
    },
    mounted() {
        this.reqSystem = (this.$route.query.reqSystem || '').trim();
        this.step = (this.$route.query.reqStep || '').trim();
        this.toolId = (this.$route.query.reqToolId || '').trim();

        let title = this.pageTitle.split(' ');
        if (!['GD', 'VD', 'HASS'].includes(this.reqSystem)) {
            this.$router.push('/');
        }

        this.getCommonHardCodeList();
        if (SDLUtil.isNull(this.pilotList)) {
            this.btnAddSerial();
        }
        if (SDLUtil.isNull(this.date)) {
            this.date = moment(new Date()).formatWithJDF(
                moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy'),
            );
        }

        this.onSearch(1);

        window.setTimeout(() => {
            this.attachToolView = true;
            window.setTimeout(() => {
                this.attachManualView = true;
            }, 1000);
        }, 1000);
    },
    methods: {
        async onSearch(v) {
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/admin/tool/toolList.skp`,
                    qs.stringify({
                        reqSystem: this.reqSystem,
                        toolId: SDLUtil.nvl(this.toolId, 'Create'),
                    }),
                )
                .then(resp => {
                    let data = resp.data.result.rowData[0];
                    if (!SDLUtil.isNull(data)) {
                        this.toolId = data.TOOL_ID;
                        this.reqSystem = data.REQ_SYSTEM;
                        this.reqType = data.REQ_TYPE;
                        this.step = data.STEP;
                        this.status = data.STATUS;
                        this.version = data.VERSION;
                        this.oldVersion = data.OLD_VERSION;
                        this.title = data.TITLE;
                        this.details = data.DESCRIPTION;
                        this.testResult = data.TEST_RESULT;
                        this.date = data.REG_DATE;
                        this.loginId = data.REG_ID;
                        this.loginName = data.REG_NAME;
                        this.approvalId = data.APPROVAL_ID;
                        this.approvalStatus = data.APPROVAL_STATUS;
                        this.attachTool = data.attachTool.rowData;
                        this.attachManual = data.attachManual.rowData;

                        let corpCode = '';
                        let ascCode = '';
                        if (!SDLUtil.isNull(data.CORP_CODE)) {
                            corpCode = data.CORP_CODE.split(',');
                        }
                        if (!SDLUtil.isNull(data.ASC_CODE)) {
                            ascCode = data.ASC_CODE.split(',');
                        }

                        this.pilotList = [];
                        for (let index = 0; index < corpCode.length; index++) {
                            this.pilotList.push({ SUBSIDIARY: corpCode[index], ASC: ascCode[index] });
                        }
                    }

                    if (0 === this.pilotList.length) {
                        this.btnAddSerial();
                    }

                    this.versionList = resp.data.search.history.rowData;

                    if ('Create' === SDLUtil.nvl(this.toolId, 'Create')) {
                        this.toolId = '';
                        if (0 < this.versionList.length) this.oldVersion = this.versionList[0].VERSION;
                    }
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        async save(v) {
            if (
                'T' === this.step &&
                (SDLUtil.isNull(this.version) ||
                    SDLUtil.isNull(this.oldVersion) ||
                    SDLUtil.isNull(this.title) ||
                    0 === this.attachToolFileSeq.length)
            ) {
                this.step = 'Q';
                this.reqType = '';
                return false;
            }

            let corpCode = '';
            let ascCode = '';

            for (const data of this.pilotList) {
                if (!SDLUtil.isNull(corpCode)) corpCode += ',';
                if (!SDLUtil.isNull(ascCode)) ascCode += ',';
                corpCode += data.SUBSIDIARY.trim();
                ascCode += data.ASC.trim();
            }

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/admin/tool/save.skp`,
                    qs.stringify({
                        toolId: this.toolId,
                        reqSystem: this.reqSystem,
                        reqType: this.reqType,
                        corpCode: corpCode,
                        ascCode: ascCode,
                        version: this.version,
                        oldVersion: this.oldVersion,
                        title: this.title,
                        details: this.details,
                        testResult: window.toolManageDetail.GetBodyValue('XHTML'),
                        step: this.step,
                        status: v,
                        path: this.path,
                        attachToolFileSeq: this.attachToolFileSeq.map(item => item.attachFileSeq),
                        delAttachToolFiles: this.delAttachToolFiles.map(item => item.attachFileSeq),
                        attachToolIsRemove: this.attachToolIsRemove,
                        attachManualFileSeq: this.attachManualFileSeq.map(item => item.attachFileSeq),
                        delattachManualFiles: this.delattachManualFiles.map(item => item.attachFileSeq),
                        attachManualIsRemove: this.attachManualIsRemove,
                    }),
                )
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    if (SDLUtil.isNull(resp.data.msg)) {
                        this.toolId = SDLUtil.nvl(resp.data.toolId);
                    } else {
                        SDLUtil.alert(resp.data.msg);
                    }

                    if (!SDLUtil.isNull(resp.data.sendUrl)) {
                        let restPopup = window.open(resp.data.sendUrl);
                        setTimeout(function() {
                            if (restPopup != null) restPopup.close();
                        }, 2000);
                    }

                    this.modify = 0;
                    this.onSearch(1);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        next(v) {
            // q t p o
            if ('Q' === v) {
                this.step = 'T';
                this.save('Ongoing');
            } else if ('T' === v) {
                this.step = 'P';
                this.save('Ongoing');
            } else if ('P' === v) {
                this.step = 'O';
                this.save('Ongoing');
            } else if ('O' === v) {
                if ('Complete' === this.status) {
                    this.save('Release');
                } else {
                    this.save('Draft');
                    this.approval();
                }
            }
        },
        request(step) {
            if ('P' === this.step && 'P' !== this.reqType) {
                for (const data of this.pilotList) {
                    if (SDLUtil.isNull(data.SUBSIDIARY.trim()) || SDLUtil.isNull(data.ASC.trim())) {
                        SDLUtil.alert('There is no ' + SDLUtil.getMsgProp('FIELD.PILOT.TESTER'));
                        return false;
                    }
                }
            }

            this.reqType = step;
            this.next(step);
        },
        pageMove(v) {
            return this.$router.push({
                path: '/basis/admin/tool/' + v + this.reqSystem,
            });
        },
        getActiveClass(v, index) {
            let result = '';
            let curIndex = 1;

            for (const iterator of this.stepList) {
                if (this.step === iterator.code) {
                    curIndex = iterator.index;
                    break;
                }
            }

            if (this.step === v) {
                result = 'active';
            } else if (index < curIndex) {
                result = 'check';
            }

            return result;
        },
        btnAddSerial() {
            this.pilotList.push({ SUBSIDIARY: '', ASC: '' });
        },
        btnRemoveSerial(idx) {
            if (!SDLUtil.isNull(this.pilotList[idx].SUBSIDIARY) || !SDLUtil.isNull(this.pilotList[idx].ASC)) {
                SDLUtil.confirm({
                    msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                    onOkEvt: () => {
                        this.pilotList.splice(idx, 1);
                    },
                });
            } else {
                this.pilotList.splice(idx, 1);
            }
        },
        async getCommonHardCodeList() {
            this.stepList = await api.getCommonHardCodeList('TOOL_STEP');
        },
        stripHtml(html) {
            var tmp = document.createElement('html');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        },
        approval() {
            if ('O' === this.step && 0 === this.attachManualFileSeq.length) {
                return false;
            }
            SDLUtil.show(
                ApprovalPopup,
                {
                    title: this.title,
                    workTable: 'TN_TOOL_MANAGER',
                    workColumn: 'TOOL_ID',
                    workKey: this.toolId,
                    rtnFunc: v => {
                        if (v) {
                            this.save('Processing');
                        }
                    },
                },
                { height: 'auto' },
            );
        },
        modifyBtn(idx) {
            this.modify = this.modify + idx;
        },
        setToolFiles(val) {
            this.attachToolFileSeq = val.fileList || [];
            this.delAttachToolFiles = val.delFileList || [];
            this.attachToolIsRemove = val.isRemove || false;
        },
        setManualFiles(val) {
            this.attachManualFileSeq = val.fileList || [];
            this.delattachManualFiles = val.delFileList || [];
            this.attachManualIsRemove = val.isRemove || false;
        },
        // 결재 이력 보기 팝업
        seeApprovalHistoryPop(approvalId) {
            SDLUtil.show(
                ApprovalHistoryPopup,
                {
                    approvalId: approvalId,
                },
                { height: 'auto' },
            );
        },
        seeNotificationPop() {
            SDLUtil.show(
                toolManagePopup,
                {
                    reqSystem: this.reqSystem,
                },
                { height: 'auto' },
            );
        },
        getMessage(v) {
            if (!SDLUtil.isNull(v)) {
                v = v.replace(/\n/g, '<br />');
            }

            return v;
        },
    },
};
</script>

<style scoped>
.toolTextArea {
    height: 120px;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/tool/toolManageDetail.vue